import { Size, Styles } from '@vivli/shared/theme';
import { ButtonView } from '@vivli/shared/views';
import { CSSProperties } from 'react';
import { IModalOptions } from '@vivli/shared/infrastructure/interface';
import { useModalApiContext } from '@vivli/core/infrastructure/context';
import { useCitationsContext } from '@vivli/shared/features/citations/infrastructure/context';
import { AddCitationComponent } from './add-citation.component';
import { EditCitationFormComponent } from './edit-citation-form.component';
import { DTIAMRCommonConst } from '@vivli/shared/infrastructure/constants';

const wrapperStyle = {
    padding: '15px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'rgb(233, 234, 239)',
} as React.CSSProperties;

const genericStyle: CSSProperties = {
    marginTop: Size.FIELD_SEPARATION,
    marginBottom: Size.FIELD_SEPARATION,
};

const oneAcrossStyleSmallNoBox: CSSProperties = {
    ...genericStyle,
    flex: '1 1 100%',
    maxWidth: '20%',
    marginLeft: 'auto',
    marginRight: 'auto',
};

export const CitationsAddButtonsComponent = () => {
    const modal = useModalApiContext();
    const { addCitation, defaultCitation, isLoading } = useCitationsContext();
    const handleAddFromDoi = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const options: IModalOptions = {
            style: wrapperStyle,
        };
        const modalId = modal.custom(
            <AddCitationComponent
                onCancel={() => modal.dismiss(modalId)}
                onSave={(citationDoi) => {
                    modal.dismiss(modalId);
                    addCitation(citationDoi, null);
                }}
            />,
            options
        );
    };
    const handleAddFromUrl = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const options: IModalOptions = {
            style: wrapperStyle,
        };
        const modalId = modal.custom(
            <EditCitationFormComponent
                citation={null}
                defaultCitationObject={defaultCitation}
                onCancel={() => modal.dismiss(modalId)}
                onSave={(citation) => {
                    modal.dismiss(modalId);
                    addCitation('', citation);
                }}
            />,
            options
        );
    };

    return (
        <div style={Styles.FORM_ROW}>
            <ButtonView
                style={oneAcrossStyleSmallNoBox}
                isLoading={isLoading}
                onClick={(e) => {
                    handleAddFromDoi(e);
                }}
                dataId={DTIAMRCommonConst.AddCitationButton('FromDOI')}
            >
                Add Citation From DOI
            </ButtonView>
            <ButtonView
                style={oneAcrossStyleSmallNoBox}
                isLoading={isLoading}
                onClick={(e) => {
                    handleAddFromUrl(e);
                }}
                dataId={DTIAMRCommonConst.AddCitationButton('Manually')}
            >
                Add Citation Manually
            </ButtonView>
        </div>
    );
};
